import {
  fetchClientLogo,
  fetchProfileConfiguration,
  fetchDecodedSessionToken,
  fetchProfileComponents,
  initClientAccount,
  accountValidation,
  microdepositsVerification,
  fetchProfilePalette,
  aisConsent,
  aisAccount,
  aisLoaded,
  microdepositLoaded,
  validationFallback,
  sessionStatus,
  notifyRedirect,
  fetchProfileAccountRegion
} from '../common/api/ClientApi';
import * as reducerConstants from './reducerConstants';
// This should go in a different package but for some reason it can't find ClientApi in a different package



// ------ SIMPLE ACTIONS ------ //

// Client
export const fetchUserSuccess = data => ({
  type: reducerConstants.FETCH_USER_SUCCESS,
  data,
});

export const fetchUserFailed = error => ({
  type: reducerConstants.FETCH_USER_FAILED,
  error,
});

// ------ COMPLEX ACTIONS ------ //

export async function createClientAccount (userConsent,country, docType, access_token, session_token) {
  const response = await initClientAccount(userConsent,country, docType, access_token, session_token);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(JSON.stringify(data));
  }
  else{
    return data;
  }
}

export async function getClientLogo (access_token, session_token) {
  return fetchClientLogo(access_token, session_token);
}

export async function getProfileConfiguration (access_token, session_token) {
  return fetchProfileConfiguration(access_token, session_token);
}

export async function getProfilePalette(access_token, session_token) {
  return fetchProfilePalette(access_token, session_token);
}

export async function getDecodedSessionToken(access_token, session_token){
  return fetchDecodedSessionToken(access_token, session_token);
}

const timer = ms => new Promise(res => setTimeout(res, ms));

export async function validateAccount(access_token, session_token) {
  return accountValidation(access_token, session_token);
}

export async function pollValidateAccount(access_token, session_token) {
  let output = await validateAccount(access_token, session_token);

  while(output && output.length !== 0 && (output[0].component === "INIT" || output[0].component === "AVS")) {
    await timer(3000);
    try {
      output = await validateAccount(access_token, session_token);
    } catch (e) {}
  }

  return output;
}

export async function verifyMicrodeposits(access_token, session_token, firstDeposit, secondDeposit) {
  return microdepositsVerification(access_token, session_token, firstDeposit, secondDeposit);
}

export async function initAisConsent(access_token, session_token, locale) {
  return aisConsent(access_token, session_token, locale);
}

export async function initAisAccount(access_token, session_token, consentId) {
  return aisAccount(access_token, session_token, consentId);
}

export async function notifyAisLoaded(access_token, session_token) {
  return aisLoaded(access_token, session_token);
}

export async function notifyMicrodepositLoaded(access_token, session_token) {
  return microdepositLoaded(access_token, session_token);
}

export async function initValidationFallback(access_token, session_token, code, description, provider, terminalState) {
  return validationFallback(access_token, session_token, code, description, provider, terminalState);
}

export async function getProfileComponents(access_token, session_token) {
  const response = await fetchProfileComponents(access_token, session_token);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(JSON.stringify(data));
  } else {
    return data;
  }
}

export async function getProfileAccountRegion(access_token, session_token) {
  const response = await fetchProfileAccountRegion(access_token, session_token);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(JSON.stringify(data));
  } else {
    return data;
  }
}

export async function checkSessionStatus(access_token, session_token) {
  return sessionStatus(access_token, session_token);
}

export async function notifyRedirectSignal(access_token, session_token, outcome) {
  return notifyRedirect(access_token, session_token, outcome);
}
